export default __webpack_public_path__ + "static/media/now_active.503b18fc.svg";